export default __webpack_public_path__ + "static/greencode-4b64956dcb41b578dad072c52292af7b.png";